<template>
    <FormSection title="DME Needed" :full-height="false" :application-id="referral.application">
        <template #content>
            <section class="row g-0 p-4 pb-0">
                <div class="col-12 py-2" v-for="(dmeNeeded, index) in referral.dmeNeeded" :key="dmeNeeded.id">
                    <CreateDmeNeededRow :dme-needed="dmeNeeded" :referral="referral" :dme-index="index" />
                </div>
                <div class="col-12 py-3">
                    <div class="col-12 form-group">
                        <button class="btn btn-md btn-primary px-3" @click="addEquipment">Add Equipment</button>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group col-12 ps-3">
                        <label for="non-standard-items"> Non Standard Items</label>
                        <CommentInput
                            input-name="referral-comments"
                            :result="referral.otherDME"
                            :classList="commentInputClass"
                            :maxLength="250"
                            :show-template-typeahead="showTemplate"
                            v-on:resultUpdatedAppended="resultUpdatedAppended"
                            v-on:resultUpdated="resultUpdated"
                        />
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./CreateDmeNeeded.ts"></script>
